import type { SVGProps } from 'react';
const SvgLayoutWindow10 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.607 17.929H3.393c-.73 0-1.322-.592-1.322-1.322V3.393c0-.73.592-1.322 1.322-1.322h13.214c.73 0 1.322.592 1.322 1.322v13.214c0 .73-.592 1.322-1.322 1.322M13.304 2.071V17.93"
    />
  </svg>
);
export default SvgLayoutWindow10;
